import { Button, Flex, Popover, TextButton } from '@bamboohr/fabric';
import { authenticateWithPasskey } from '@bamboohr/utils/lib/authentication';
import React, { useRef, useState } from 'react';
import { PasskeyFacts } from './passkey-facts';

export interface PasskeyLoginButtonProps {
	isKnownUser?: boolean;
}

export const PasskeyLoginButton: React.FC<PasskeyLoginButtonProps> = ({
	isKnownUser = false,
}) => {
	const popoverButtonRef = useRef<HTMLButtonElement>(null);
	const [isPopoverOpen, setIsPopoverOpen] = useState(false);

	return (
		<Flex flexDirection="column" gap={1.5}>
			<Button
				onClick={() => {
					authenticateWithPasskey();
				}}
				size="large"
				startIcon="keypass-regular"
				type="button"
				width={9}
			>
				{$.__('Log in with a Passkey')}
			</Button>
			{!isKnownUser && (
				<>
					<TextButton
						onClick={() => setIsPopoverOpen(!isPopoverOpen)}
						ref={popoverButtonRef}
						size="small"
						startIcon="circle-question-regular"
						type="button"
					>
						{$.__('What are passkeys?')}
					</TextButton>
					<Popover
						anchorEl={popoverButtonRef.current}
						hasMaxWidth={false}
						onClose={() => setIsPopoverOpen(false)}
						open={isPopoverOpen}
						placement="top"
						title={$.__('What are passkeys?')}
					>
						<PasskeyFacts hasMaxWidth={true} />
					</Popover>
				</>
			)}
		</Flex>
	);
};
